//packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom'
import _ from 'lodash'
import moment from 'moment'

//drupal old addons
import './date.format'

//constants
const defaultFormats = {
    calendar: 'MM/DD/YYYY',
    time: 'hh:mm a',
    dateTime: 'MM/DD/YYYY hh:mm a'
};

//styles
import 'classlist-polyfill'
import 'react-widgets/lib/less/react-widgets.less'
import './DateTimePicker.less'

class DateTimePicker extends Component {
    static propTypes = {
        title: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.array,
            PropTypes.string,
            PropTypes.number,
        ]),

        format: PropTypes.string,

        time: PropTypes.bool,
        calendar: PropTypes.bool,

        onChange: PropTypes.func,

        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object,
        ]),

        min: PropTypes.object,
        max: PropTypes.object,
    };

    constructor(props) {
        super();

        const {time, calendar, value} = props;

        const format = props.format || (
            time && calendar ? defaultFormats.dateTime :
                time ? defaultFormats.time : defaultFormats.calendar
        );

        this.state = {
            value: value ? moment(value).format(format) : '',
            format,
            isValueChangedByKeyDown: false,
        };
    }

    static defaultProps = {
        onChange: () => null,

        value: new Date(),

        title: 'Date',

        time: false,
        calendar: true,
    };

    componentDidMount() {
        this.dateTimeInit();
    }

    dateTimeInit(props = this.props) {
        const {time, calendar, min, max} = props;

        //user should set "true" (boolean) one of props: time or calendar.
        if (!time && !calendar) {
            throw new Error('Select at least one of parameters: calendar or time.');
        }

        const valueChangeFunc = this.valueChange.bind(this);
        const timeParams = {
            controlType: 'select',
            timeFormat: 'hh:mm tt',
            showTime: false,
            showMinute: false,
            onSelect: valueChangeFunc,
            hourText: 'Time' + dateFormat(' (Z) '),
        };

        if (min) {
            timeParams.minDate = min;
        }

        if (max) {
            timeParams.maxDate = max;
        }

        const target = $(ReactDOM.findDOMNode(this.refs.dateTimePicker));
        if (time && calendar) {
            target.datetimepicker(timeParams);
        } else if (time) {
            target.timepicker(timeParams);
        } else {
            target.datepicker(timeParams);
        }
    }

    componentWillReceiveProps(props) {
        const {min, max, value, time, calendar} = props;

        const target = $(ReactDOM.findDOMNode(this.refs.dateTimePicker));
        if (time !== this.props.time || calendar !== this.props.calendar) {
            if (this.props.time && this.props.calendar) {
                target.datetimepicker('destroy');
            } else if (this.props.time) {
                target.timepicker('destroy');
            } else {
                target.datepicker('destroy');
            }

            return this.dateTimeInit();
        }

        const dateValueFormatted = value ? moment(value).format(this.state.format) : '';

        const options = {};
        if (this.props.min && (!moment(min).isSame(this.props.min, 'day') )) {
            options.minDate = min;
        }

        if (this.props.max && (!moment(max).isSame(this.props.max, 'day') )) {
            options.maxDate = max;
        }

        if (!_.isEmpty(options)) {
            if (time && calendar) {
                target.datetimepicker('option', options);
            } else if (time) {
                target.timepicker('option', options);
            } else {
                target.datepicker('option', options);
            }
        }

        if (this.state.value !== dateValueFormatted) {
            this.setState({value: dateValueFormatted});
        }
    }

    valueChange(e) {
        const value = _.get(e, 'target.value', e);

        const isValueChangedByKeyDown = !!e.target;

        //if changed in line by typing
        if (this.state.isValueChangedByKeyDown && !isValueChangedByKeyDown) {
            this.props.onChange(new Date(value));
            return this.setState({
                value: moment(value).format(this.state.format),
                isValueChangedByKeyDown
            });
        }

        this.setState({
            value,
            isValueChangedByKeyDown
        });

        if (!isValueChangedByKeyDown) {
            this.props.onChange(new Date(this.state.value));
        }
    };

    onBlur = () => {
        if (!this.state.isValueChangedByKeyDown) return;
        this.props.onChange(new Date(this.state.value));
    };

    render() {
        const {
            title,
            time
        } = this.props;

        return (
            <div className={`date-picker-custom date-picker-type-${time ? 'datetime-picker' : 'date-picker'}`}>
                <label className="selector-label">{title}</label>
                <div className="date-picker-container">
                    <div>
                        <span>
                            <div>
                                <input
                                    className="Select-value-label"
                                    ref="dateTimePicker"
                                    type="text"
                                    value={this.state.value}
                                    onChange={this.valueChange.bind(this)}
                                    onBlur={this.onBlur}
                                />
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        )
    }
}

export default DateTimePicker



/** WEBPACK FOOTER **
 ** ./src/components/Modules/DateTimePicker/DateTimePicker.js
 **/